import { tsl_projektdeltagande_tsl_anstallningsform } from '../../../../../types/Enums/Generated/tsl_projektdeltagande_tsl_anstallningsform';

export const EmploymentType = tsl_projektdeltagande_tsl_anstallningsform;

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    value: String(
      tsl_projektdeltagande_tsl_anstallningsform.Tillsvidareanstlld
    ),
    label: 'Tillsvidare',
  },
  {
    value: String(
      tsl_projektdeltagande_tsl_anstallningsform.Tidsbegrnsatanstlld
    ),
    label: 'Tidsbegränsad',
  },
];

/** Shape held in react-hook-form state. Everything is a string so inputs stay controlled. */
export type TerminatedEmployeeInput = {
  socialSecurityNumber: string;
  firstName: string;
  lastName: string;
  employmentType: string;
  // used to render date warning when an employment date is missing
  employmentDate?: string;
  startDate: string;
  terminationDate: string;
  endDate: string;
  email: string;
  phone: string;
};

export type TerminatedEmployeeField = keyof TerminatedEmployeeInput;

export type EmployeeWarning = {
  field?: TerminatedEmployeeField;
  message: string;
};

export type EmployeeRowStatus = 'error' | 'warning' | 'valid';

export type EmployeeRow = {
  /** Stable react-hook-form field id, survives filtering and removal. */
  fieldId: string;
  formIndex: number;
  employee: TerminatedEmployeeInput;
  errors: Partial<Record<TerminatedEmployeeField, string>>;
  warnings: EmployeeWarning[];
  status: EmployeeRowStatus;
  searchText: string;
};

export type EmployeeRowFilter = 'all' | 'errors' | 'warnings';

export type ImportedEmployee = {
  rowNumber: number;
  socialSecurityNumber: string;
  firstName: string;
  lastName: string;
  employmentType: number | null;
  startDate: string;
  terminationDate: string;
  endDate: string;
  email: string;
  phone: string;
};

export type ImportError = {
  rowNumber: number | null;
  column: string | null;
  code?: string | null;
  tokens?: Record<string, string> | null;
  message: string;
};

export type ImportTerminatedEmployeesResponse = {
  success: boolean;
  totalRows: number;
  employees: ImportedEmployee[];
  errors: ImportError[];
};
